import React,{useRef, useState, useEffect} from "react";

import {Form, Col, Row, Spinner } from "react-bootstrap";

class EditableRange extends React.Component {

	
	
	constructor(props) {
		
		super(props);
		this.input = React.createRef();
		this.range = React.createRef();
		
		
		this.state = {
			value: this.props.value
		};
		
	}

	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}
	handleOnChange(e, update){

		if(this.props.onMouseUp)
			this.props.onMouseUp(e.target.value);
		
		if(this.props.onChange)
			this.props.onChange(e);

		if(update)
			this.updateStatus({value:e.target.value});
	}
	handleOnMouseUp(value){
		
		if(this.props.onMouseUp)
			this.props.onMouseUp(value);
	}
	handleInput(e){
		
		var original = e.target.value.replace(",", ".");
		
		var input = parseFloat(original);
		
		if(!isNaN(input)){
			e.target.value=original;
			this.handleOnChange(e);
			this.handleOnMouseUp(original);
			e.target.classList.remove("border-danger");
		}
		else {
			e.target.classList.add("border-danger");
		}
		this.updateStatus({value:original});
	}
	handleKeyPress(e){
		e.stopPropagation();
		
		var step = Number(this.props.step);
		var max = Number(this.props.max);
		var min = Number(this.props.min);
		var decimals = Math.floor(step.valueOf()) === step.valueOf() ? 0 : (step.toString().split(".")[1].length || 0);
		
		if(e.keyCode == 40){
			//down
			var input = Number((Number(e.target.value)*100 - step*100)/100).toFixed(Number.isInteger(step) ? 0 : decimals);
			
			e.target.value = input < min ? min : input;
			this.range.current.value = input;
			
		}
		else if(e.keyCode == 38){
			//up
			var input = Number((Number(e.target.value)*100 + step*100)/100).toFixed(Number.isInteger(step) ? 0 : decimals);
			
			e.target.value = input > max ? max : input;
			
			this.range.current.value = input;
			
		}
		this.handleOnChange(e, true);
		e.target.classList.remove("border-danger");
	}

	render() {
		
		return (
			<div className={"editableRange " + this.props.wrpClassName}>
				<Form.Range name={this.props.name} ref={this.range} className={this.props.className} min={this.props.min} max={this.props.max} step={this.props.step} value={this.state.value} defaultValue={this.state.value} onMouseUp={(e)=>(this.handleOnMouseUp(e.target.value))} onChange={(e)=>(this.handleOnChange(e, true))} />
				<input ref={this.input} onKeyDown={(e)=>{this.handleKeyPress(e);}} className="manual form-control" type="text" value={this.state.value} defaultValue={this.state.value} onInput={(e)=>this.handleInput(e)} />
			</div>
			
		);
			
		
	}
}

export default EditableRange;